module.exports = "<app-nav></app-nav>\n<main><app-main></app-main></main>\n<app-footer></app-footer>"